import { appNotificationsReducer as appNotifications } from './appNotification';
import { navTreeReducer as navBarTree } from './navBarTree';
import { navIndexReducer as navIndex } from './navModel';

export default {
  navBarTree,
  navIndex,
  appNotifications,
};
